module.exports = __webpack_public_path__ + "media/icons/chevron-down-bc2137723848e2215404c0b69c468c7c.svg";